import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import "whatwg-fetch"
import ConnectButtonForm from "../../common/ConnectButtonForm";
import WindowEventHelper from "../../../lib/WindowEventHelper";

class GoogleSearchConsoleForm extends Component {
  isValidSetting(setting) {
    return !!setting.isValidToken && !!setting.hasSiteOwnership && !!setting.hasTokenMapper
  }

  componentDidMount() {
    const { plugin, data, onChange } = this.props
    if (!plugin.active) {
      onChange(update(data, {
        setting: {
          isValidToken: {
            $set: false
          },
          hasSiteOwnership: {
            $set: false
          },
          hasTokenMapper: {
            $set: false
          },
          siteUrl: {
            $set: ''
          }
        },
        validated: {
          $set: !!data.setting.googleCredits
        }
      }))
    }

    if (plugin.active && !this.isValidSetting(data.setting)) {
      alert('플러그인 사용을 위해 인증 상태 재확인이 필요합니다.\n계정 연결하기를 다시 진행하신 후, 변경사항을 적용해주세요.')
    }

    WindowEventHelper.add("message", this.handleReceivePostMessage)
  }

  componentWillUnmount() {
    WindowEventHelper.remove("message", this.handleReceivePostMessage)
  }

  @autobind
  handleConnect() {
    window.open('/oauth/google','GoogleOAuth2','width=800,height=850,toolbar=no,menubar=no,location=no,scrollbars=no,status=no');
  }

  @autobind
  handleReceivePostMessage(e) {
    const { data, onChange } = this.props

    if (e.data && e.data.name === 'GoogleSearchConsole') {
      onChange(update(data, {
        setting: {
          googleCredits: {
            $set: e.data.googleCredits
          },
          googleSiteVerificationCode: {
            $set: e.data.googleSiteVerificationCode
          }
        },
        validated: {
          $set: !!e.data.googleCredits && !!e.data.googleSiteVerificationCode
        }
      }))
    }
  }

  renderConnectedBox() {
    const { data } = this.props
    const searchConsoleUri = `https://search.google.com/search-console?resource_id=${data.setting.siteUrl}`
    const searchConsoleOutLinkButtonStyle = {
      fontSize: '12px',
      color: '#808080'
    }

    return (
      <div className="info_plugin">
        <div className="box_plugin">
          <p>
            Google Search Console에 블로그가 올바르게 등록되었습니다.
            {
              !!data.setting.hasSiteOwnership &&
              <span>
                &nbsp;&nbsp;
                < a href={searchConsoleUri} target="_blank" style={ searchConsoleOutLinkButtonStyle }>(바로가기)</a>
              </span>
            }
          </p>
        </div>
      </div>
    )
  }

  renderConnectButton() {
    return (
      <div className="wrap_btn">
        <ConnectButtonForm onClick={this.handleConnect} />
        <span className="txt_other">연결 페이지가 보이지 않으시면 브라우저의 팝업 허용 여부를 확인해 주세요.</span>
      </div>
    )
  }

  isConnected(data, plugin) {
    return plugin.active && !data.setting.googleCredits
      ? this.isValidSetting(data.setting) && !!data.setting.googleSiteVerificationCode
      : !!data.setting.googleCredits && !!data.setting.googleSiteVerificationCode
  }

  render() {
    const { data, plugin } = this.props
    return (
      <div className="desc_plugin32">
        <p className="txt_plugin">
          구글 서치콘솔에 블로그를 손쉽게 등록하고 사이트맵을 자동으로 제출할 수 있습니다.
          { !plugin.active && <a href="https://search.google.com/search-console" target="_blank" className="link_other">서치콘솔 바로가기</a> }
        </p>

        { this.isConnected(data, plugin) ? this.renderConnectedBox() : this.renderConnectButton() }

        <div className="info_pluginline">
          <strong className="tit_set">설정 방법</strong>
          <ol className="list_plugin">
            <li>
              <span className="txt_em">1</span>
              계정 연결하기로 서치콘솔을 사용할 구글 계정에 로그인해주세요.
            </li>
            <li>
              <span className="txt_em">2</span>
              블로그 등록 및 사이트맵 제출을 위해 권한 요청에 '허용'을 클릭해주세요.
            </li>
            <li>
              <span className="txt_em">3</span>
              화면 오른쪽 아래의 '적용' 버튼을 누르시면 모든 설정이 완료됩니다.
            </li>
          </ol>
        </div>
        {this.props.saveButton()}
      </div>
    )
  }
}

GoogleSearchConsoleForm.propTypes = {
  plugin: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default GoogleSearchConsoleForm
